import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getFirestore,
  collection,
  getDocs,
  doc,
  setDoc,
  Timestamp,
  onSnapshot,
  query,
  where
} from "firebase/firestore";
import app from "../firebase";
import "./MenuLateralBombero.css";
import Bomberos81Modal from "./Bomberos81Modal";

// ✅ NUEVO: modal Botón Rojo CONAF (tarjetas)
import BotonRojoConafModal from "./BotonRojoConafModal";

// ✅ NUEVO: modal Mantenimiento Unidades
import MantenimientoUnidadesModal from "./MantenimientoUnidadesModal";
import { useCuerpo } from "../context/CuerpoContext";

const db = getFirestore(app);

// Mapa de slug de compañía en la URL -> nombre de compañía
const CIA_MAP = {
  kf83mx: "Primera Compañía",
  zl29qp: "Segunda Compañía",
  rd77lt: "Tercera Compañía",
  vb52cz: "Cuarta Compañía",
  wn64dy: "Quinta Compañía",
};

// Obtiene la compañía actual leyendo la URL (/cia/<slug>)
function getCompaniaActualFromLocation() {
  if (typeof window === "undefined") return null;
  const path = window.location.pathname || "";
  const match = path.match(/\/cia\/([^/]+)/);
  const slug = match ? match[1] : null;
  if (!slug) return null;
  const nombre = CIA_MAP[slug];
  if (!nombre) return null;
  return { slug, nombre };
}

// Normaliza nombre de compañía para comparar sin tildes / mayúsculas / espacios
function normCompaniaName(str) {
  return String(str || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "") // quitar tildes
    .replace(/\s+/g, "");
}

function sameCompaniaName(a, b) {
  if (!a || !b) return false;
  return normCompaniaName(a) === normCompaniaName(b);
}

const MenuLateralBombero = ({ onClose, onConfirmacion }) => {
  const navigate = useNavigate();
  const { cuerpoId, cuerpoSlug } = useCuerpo();

  const [show81, setShow81] = useState(false);

  // ✅ NUEVO: estado modal Botón Rojo
  const [showBotonRojo, setShowBotonRojo] = useState(false);

  // ✅ NUEVO: estado modal Mantenimiento Unidades
  const [showMantUnidades, setShowMantUnidades] = useState(false);

  const [rut, setRut] = useState("");
  const [ubicacion, setUbicacion] = useState("cuartel");
  // const [maquinista, setMaquinista] = useState(false);
  // const [unidades, setUnidades] = useState([]);
  const [horaInicio, setHoraInicio] = useState("");
  const [horaTermino, setHoraTermino] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [count81, setCount81] = useState(0);

  // Compañía actual según la URL (ej: /cia/kf83mx)
  const companiaActual = React.useMemo(() => getCompaniaActualFromLocation(), []);

  const generarOpcionesHoras = () => {
    const opciones = [];
    for (let h = 0; h < 24; h++) {
      ["00", "15", "30", "45"].forEach((m) => {
        const time = `${h.toString().padStart(2, "0")}:${m}`;
        opciones.push(time);
      });
    }
    return opciones;
  };

  const formatearRUT = (rut) => {
    rut = rut.replace(/[^0-9kK]/g, "").toUpperCase();
    if (rut.length < 2) return rut;
    const cuerpo = rut.slice(0, -1);
    const dv = rut.slice(-1);
    return `${cuerpo}-${dv}`;
  };

  const enviarEstado = async () => {
    if (!rut.trim()) return alert("Debes ingresar un RUT");
    if (!horaInicio || !horaTermino)
      return alert("Debes especificar hora de inicio y término");

    const rutFormateado = formatearRUT(rut.trim());

    // Usamos base consistente para que móviles no generen desfases
    const baseDate = new Date();
    baseDate.setSeconds(0);
    baseDate.setMilliseconds(0);

    const [inicioHoras, inicioMinutos] = horaInicio.split(":").map(Number);
    const [terminoHoras, terminoMinutos] = horaTermino.split(":").map(Number);

    const horaInicioDate = new Date(baseDate);
    horaInicioDate.setHours(inicioHoras, inicioMinutos, 0, 0);

    // usamos let porque la vamos a ajustar si cruza medianoche
    let horaTerminoDate = new Date(baseDate);
    horaTerminoDate.setHours(terminoHoras, terminoMinutos, 0, 0);

    // 🔁 NUEVO: comparar hora inicio con hora actual en Chile
    const ahoraChile = new Date().toLocaleString("en-US", {
      timeZone: "America/Santiago",
    });
    const ahoraChileDate = new Date(ahoraChile);

    if (isNaN(horaInicioDate.getTime()) || isNaN(horaTerminoDate.getTime())) {
      alert("Las horas seleccionadas no son válidas.");
      return;
    }

    // ⏱️ Si inicio y término son exactamente la misma hora -> error
    const mismoHorario =
      inicioHoras === terminoHoras && inicioMinutos === terminoMinutos;
    if (mismoHorario) {
      alert("La hora de término debe ser distinta a la hora de inicio.");
      return;
    }

    // 🌙 Permitir turnos que cruzan la medianoche:
    // si la hora de término es menor o igual que la de inicio,
    // asumimos que termina al día siguiente.
    if (horaTerminoDate <= horaInicioDate) {
      horaTerminoDate.setDate(horaTerminoDate.getDate() + 1);
    }

    if (horaInicioDate < ahoraChileDate) {
      alert("La hora de inicio no puede ser menor a la hora actual.");
      return;
    }

    console.log(
      "DEBUG -> horaInicio:",
      horaInicioDate,
      "horaTermino (ajustada):",
      horaTerminoDate
    );
    console.log("Hora actual Chile:", ahoraChileDate);

    setEnviando(true);

    let exito = false;

    try {
      if (!cuerpoId) throw new Error("No se pudo resolver el Cuerpo de Bomberos activo");

      // 1) Buscar bombero SOLO dentro del Cuerpo activo
      const snapshot = await getDocs(
        query(collection(db, "bomberos"), where("cuerpo_id", "==", cuerpoId))
      );
      const bomberoDoc = snapshot.docs.find(
        (docSnap) => formatearRUT(docSnap.data().rut) === rutFormateado
      );

      if (!bomberoDoc) {
        alert("RUT no encontrado en la base de datos");
        setEnviando(false);
        return;
      }

      const data = bomberoDoc.data();
      const companiaBombero = data.compania || data.compañía || "";

      // ✅ Validar que el bombero pertenezca a la compañía de esta plataforma
      if (companiaActual && !sameCompaniaName(companiaBombero, companiaActual.nombre)) {
        alert(
          `Este bombero pertenece a "${companiaBombero}", pero esta es la plataforma de "${companiaActual.nombre}".`
        );
        setEnviando(false);
        return;
      }

      // 2) 🚫 Bloquear si el bombero está FUERA DE SERVICIO en este momento
      const fueraSnap = await getDocs(
        query(collection(db, "bomberos_fuera_servicio"), where("cuerpo_id", "==", cuerpoId))
      );
      let estaFueraServicio = false;
      let finFueraServicio = null;

      fueraSnap.forEach((d) => {
        const x = d.data && d.data();
        if (!x) return;

        if (x.visible === false) return;

        const ini = x.fecha_inicio?.toDate ? x.fecha_inicio.toDate() : null;
        const fin = x.fecha_fin?.toDate ? x.fecha_fin.toDate() : null;
        if (!ini || !fin) return;

        // ¿Está activo el periodo 8-1?
        if (!(ini <= ahoraChileDate && ahoraChileDate <= fin)) return;

        const rutDoc =
          x.rut ? formatearRUT(String(x.rut)) : null;
        const idDoc =
          d.id ? formatearRUT(String(d.id)) : null;

        if (rutDoc === rutFormateado || idDoc === rutFormateado) {
          estaFueraServicio = true;
          finFueraServicio = fin;
        }
      });

      if (estaFueraServicio) {
        let msg =
          "Este bombero está registrado como FUERA DE SERVICIO en este momento.\n" +
          "Debe finalizar su periodo fuera de servicio antes de ponerse en servicio.";
        if (finFueraServicio instanceof Date) {
          const finTexto = finFueraServicio.toLocaleString("es-CL", {
            timeZone: "America/Santiago",
          });
          msg += `\n\nFin programado del periodo fuera de servicio: ${finTexto}`;
        }
        alert(msg);
        setEnviando(false);
        return;
      }

      // 3) Registrar en bomberos_en_servicio
      const nuevoDoc = {
        id: rutFormateado,
        cuerpo_id: cuerpoId,
        nombre: data.nombre,
        cargo: data.cargo,
        maquinista: data.maquinista || false,
        unidades: Array.isArray(data.unidades) ? data.unidades : [],
        compania: data.compania,
        fotoURL: data.fotoURL || "",
        ubicacion,
        color: data.color || "#999",
        horaInicioServicio: Timestamp.fromDate(
          new Date(horaInicioDate.getTime())
        ),
        horaTerminoServicio: Timestamp.fromDate(
          new Date(horaTerminoDate.getTime())
        ),
      };

      await setDoc(doc(db, "bomberos_en_servicio", rutFormateado), nuevoDoc);

      // limpiar formulario
      setRut("");
      setUbicacion("cuartel");
      setHoraInicio("");
      setHoraTermino("");

      exito = true;
    } catch (error) {
      console.error("Error al enviar estado:", error);
      alert(
        "Ocurrió un error al enviar el estado.\n" +
          (error && error.message ? `Detalle: ${error.message}` : "")
      );
    } finally {
      setEnviando(false);
    }

    // 🔔 Confirmar y cerrar menú SOLO si todo salió bien
    if (exito) {
      if (typeof onConfirmacion === "function") {
        try {
          onConfirmacion();
        } catch (e) {
          console.error("Error en onConfirmacion:", e);
        }
      }
      if (typeof onClose === "function") {
        try {
          onClose(); // 👉 cierra el menú lateral automáticamente
        } catch (e) {
          console.error("Error al cerrar menú:", e);
        }
      }
    }
  };

  const opcionesHoras = generarOpcionesHoras();

  // Contador 8-1 (activos ahora, zona horaria Chile y visible:true)
  React.useEffect(() => {
    try {
      const unsub = onSnapshot(
        query(
          collection(db, "bomberos_fuera_servicio"),
          where("cuerpo_id", "==", cuerpoId)
        ),
        (snap) => {
          const nowLocal = new Date();
          const nowChile = new Date(
            nowLocal.toLocaleString("en-US", { timeZone: "America/Santiago" })
          );
          let activos = 0;
          snap.forEach((d) => {
            const x = d.data && d.data();
            if (!x?.visible) return;

            const ciaDoc =
              x.compania || x.compañía || x.companiaNombre || "";

            // ✅ Solo contar bomberos de la compañía actual (según URL)
            if (
              companiaActual &&
              !sameCompaniaName(ciaDoc, companiaActual.nombre)
            ) {
              return;
            }

            const ini = x.fecha_inicio?.toDate
              ? x.fecha_inicio.toDate()
              : null;
            const fin = x.fecha_fin?.toDate ? x.fecha_fin.toDate() : null;
            if (!ini || !fin) return;

            if (ini <= nowChile && nowChile <= fin) activos += 1;
          });
          setCount81(activos);
        }
      );
      return () => unsub && unsub();
    } catch (e) {
      // silencioso
    }
  }, [companiaActual, cuerpoId]);

  // 🔧 Ajuste visual: alto cómodo en pantallas pequeñas
  const controlStyle = {
    width: "100%",
    maxWidth: "100%",
    boxSizing: "border-box",
    minHeight: "80px",
    padding: "6px",
    lineHeight: "1.2",
    fontSize: "1rem",
  };

  const rutStyle = {
    ...controlStyle,
    minHeight: "40px",
  };

  return (
    <div className="menu-lateral">
      <h3>Ingresar Estado</h3>

      <input
        type="text"
        placeholder="RUT (e.j. 12345678-9)"
        value={rut}
        onChange={(e) => setRut(e.target.value)}
        style={rutStyle}
      />

      <label>Ubicación:</label>
      <select
        value={ubicacion}
        onChange={(e) => setUbicacion(e.target.value)}
        style={controlStyle}
      >
        <option value="cuartel">En el Cuartel</option>
        <option value="casa">Domicilio</option>
        <option value="trabajo">Trabajo</option>
        <option value="8-6">(8-6)</option>
      </select>

      <label>Hora Inicio:</label>
      <select
        value={horaInicio}
        onChange={(e) => setHoraInicio(e.target.value)}
        style={controlStyle}
      >
        <option value="">--</option>
        {opcionesHoras.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>

      <label>Hora Término:</label>
      <select
        value={horaTermino}
        onChange={(e) => setHoraTermino(e.target.value)}
        style={controlStyle}
      >
        <option value="">--</option>
        {opcionesHoras.map((h) => (
          <option key={h} value={h}>
            {h}
          </option>
        ))}
      </select>

      <button onClick={enviarEstado} disabled={enviando}>
        {enviando ? "Enviando..." : "Enviar"}
      </button>

      <button onClick={onClose}>Cerrar</button>

      <div style={{ marginTop: 8 }}>
        Bomberos Fuera de Servicio: {count81}
      </div>

      {/* Acceso directo a Bomberos 8-1 */}
      <div
        className="ml-acciones-extra"
        style={{
          marginTop: 12,
          padding: 10,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => setShow81(true)}
          className="btn-81"
          style={{
            background: "#e53935",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
          }}
        >
          Bomberos 0-8
        </button>
      </div>

      {/* ✅ Acceso a Partes */}
      <div
        style={{
          marginTop: 0,
          paddingTop: 0,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => navigate(`/${cuerpoSlug}/partes`)}
          style={{
            width: "100%",
            background: "#0f172a",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontWeight: 600,
          }}
          title="Ingresar al módulo de Partes"
        >
          🧾 Partes
        </button>
      </div>

      {/* ✅ Botón Rojo CONAF */}
      <div
        style={{
          marginTop: 0,
          paddingTop: 0,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => setShowBotonRojo(true)}
          style={{
            width: "100%",
            background: "#111827",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontWeight: 700,
          }}
          title="Ver comunas con Botón Rojo activo (CONAF)"
        >
          🟥 Botón Rojo CONAF
        </button>
      </div>

      {/* ✅ Mantenimiento Unidades */}
      <div
        style={{
          marginTop: 0,
          paddingTop: 0,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => setShowMantUnidades(true)}
          style={{
            width: "100%",
            background: "#0b1220",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontWeight: 800,
          }}
          title="Ver y gestionar vencimientos y mantenciones de unidades"
        >
          🚒 Mantención Unidades
        </button>
      </div>

      {/* Organigrama público del Cuerpo */}
      <div
        style={{
          marginTop: 0,
          paddingTop: 0,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => {
            navigate(`/${cuerpoSlug}/organigrama`);
            if (onClose) onClose();
          }}
          style={{
            width: "100%",
            background: "#0f172a",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontWeight: 700,
          }}
          title="Ver organigrama del Cuerpo de Bomberos"
        >
          🗂️ Organigrama
        </button>
      </div>

      {/* ✅ Administración al final del grupo, con el mismo estilo visual de Partes */}
      <div
        style={{
          marginTop: 0,
          paddingTop: 0,
          borderTop: "1px solid #2a3442",
        }}
      >
        <button
          type="button"
          onClick={() => {
            if (cuerpoSlug) {
              sessionStorage.setItem("superadmin_cuerpo_slug", cuerpoSlug);
            }
            navigate("/admin-login");
            if (onClose) onClose();
          }}
          style={{
            width: "100%",
            background: "#0f172a",
            color: "#fff",
            border: "none",
            borderRadius: 10,
            padding: "10px 14px",
            cursor: "pointer",
            fontWeight: 600,
          }}
          title="Ingresar al panel de administración"
        >
          ⚙️ Administración
        </button>
      </div>

      {show81 && (
        <Bomberos81Modal
          open={show81}
          onClose={() => setShow81(false)}
        />
      )}

      {/* ✅ NUEVO: Modal Botón Rojo */}
      {showBotonRojo && (
        <BotonRojoConafModal
          open={showBotonRojo}
          onClose={() => setShowBotonRojo(false)}
        />
      )}

      {/* ✅ NUEVO: Modal Mantenimiento Unidades */}
      {showMantUnidades && (
        <MantenimientoUnidadesModal
          open={showMantUnidades}
          companiaActual={companiaActual}
          onClose={() => setShowMantUnidades(false)}
        />
      )}

      {/* Firma / crédito */}
      <div className="firma-autor">
        <hr className="firma-sep" />
        <div className="firma-texto">
          <div className="firma-titulo">Plataforma creada por:</div>
          <div className="firma-nombre">Max Kendall Blanch Muñoz</div>
          <a className="firma-mail" href="mailto:contacto@digitalevolution.cl">
            contacto@digitalevolution.cl
          </a>
        </div>

        <img
          className="firma-logo"
          src="/firma/digital-evolution.png"
          alt="Digital Evolution"
          loading="lazy"
        />
      </div>
    </div>
  );
};

export default MenuLateralBombero;
